import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http';
import type { ProjectContext } from '@models/project-context.model';

@Service()
export class ProjectContextService {
  private readonly http = inject(HttpService);

  async getProjectContextAsync(projectId: string): Promise<ProjectContext> {
    return this.http.getObjectAsync<ProjectContext>(`mobile/projects/${projectId}/context`);
  }
}
